/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VerifyPinRequest
 */
export interface VerifyPinRequest {
    /**
     * 
     * @type {string}
     * @memberof VerifyPinRequest
     */
    pin: string;
}

/**
 * Check if a given object implements the VerifyPinRequest interface.
 */
export function instanceOfVerifyPinRequest(value: object): value is VerifyPinRequest {
    if (!('pin' in value) || value['pin'] === undefined) return false;
    return true;
}

export function VerifyPinRequestFromJSON(json: any): VerifyPinRequest {
    return VerifyPinRequestFromJSONTyped(json, false);
}

export function VerifyPinRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerifyPinRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'pin': json['pin'],
    };
}

export function VerifyPinRequestToJSON(json: any): VerifyPinRequest {
    return VerifyPinRequestToJSONTyped(json, false);
}

export function VerifyPinRequestToJSONTyped(value?: VerifyPinRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pin': value['pin'],
    };
}

